module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "diogenes.842f2256.png";